export default __webpack_public_path__ + "static/media/notification.d5c24183.svg";